import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const TABS = [
  { to: '/privacy', label: 'Gizlilik' },
  { to: '/kvkk', label: 'KVKK' },
  { to: '/terms', label: 'Kullanım Koşulları' },
];

const LegalLayout = ({ title, lastUpdated, children, backTo = '/login' }) => {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-background text-gray-300 px-4 py-10">
      <div className="max-w-2xl mx-auto">
        <p className="mb-6">
          <Link to={backTo} className="text-sm text-violet-400 hover:text-violet-300">
            ← Geri
          </Link>
        </p>

        <h1
          className="text-2xl font-bold text-white mb-1"
          style={{ fontFamily: 'Cinzel, serif' }}
        >
          {title}
        </h1>
        <p className="text-xs text-gray-500 mb-2">DEKOSTA</p>
        {lastUpdated && (
          <p className="text-xs text-gray-500 mb-6">Son güncelleme: {lastUpdated}</p>
        )}

        <nav className="flex gap-3 mb-6 border-b border-white/10 pb-3 text-sm">
          {TABS.map((t) => {
            const active = pathname === t.to;
            return (
              <Link
                key={t.to}
                to={t.to}
                className={
                  active
                    ? 'text-violet-300 font-semibold border-b-2 border-violet-400 pb-1'
                    : 'text-gray-400 hover:text-violet-300 pb-1'
                }
              >
                {t.label}
              </Link>
            );
          })}
        </nav>

        <div className="space-y-6 text-sm leading-relaxed">{children}</div>
      </div>
    </div>
  );
};

export default LegalLayout;
